export default {"src":"/_next/static/media/close.4593c997.svg","height":40,"width":40};